import { FaroTextButton } from "@components/common/faro-text-button";
import { BasicTabProps } from "@components/common/tabs/tabs-type";
import { blue, neutral } from "@flat-ui";
import { DEFAULT_INPUT_FONT_SIZE } from "@styles/common-styles";
import { OpenTabEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { useLocation } from "react-router-dom";

interface Props<K> extends BasicTabProps<K> {
  /** Whether the tab is currently selected */
  isSelected?: boolean;

  /**
   * The name of the event to track opening tab events.
   * In the same page all opening of a tab is tracked with the same event name,
   * and the tab name is sent as a prop.
   */
  trackingEventPageName: OpenTabEvents;
}

/** A single tab item shown in the vertical tabs */
export function TabItem<K extends string>({
  label,
  isHidden,
  isSelected,
  routeId,
  trackingEventPageName,
}: Props<K>): JSX.Element | null {
  const { trackEvent } = useTrackEvent();
  const { search } = useLocation();

  if (isHidden) {
    return null;
  }

  return (
    <FaroTextButton
      key={label}
      sx={{
        mb: "24px",
        pl: "0px",
        color: isSelected ? blue[500] : neutral[800],
        fontSize: DEFAULT_INPUT_FONT_SIZE,
        fontWeight: isSelected ? "bold" : "normal",
        justifyContent: "flex-start",
      }}
      shouldHideFocusingEffect={true}
      shouldHideHoveringEffect={true}
      to={`../${routeId}${search}`}
      onClick={() => {
        trackEvent({
          name: trackingEventPageName,
          props: {
            tab: routeId,
          },
        });
      }}
    >
      {label}
    </FaroTextButton>
  );
}
